<template>
    <dialog
        ref="dialog"
        :id="propsData.id"
        class="backdrop:cursor-pointer backdrop:bg-[rgb(0_0_0_/_0.50)] backdrop:transition-opacity backdrop:duration-200 backdrop:ease-out"
        :class="{'backdrop:opacity-0': !isActive}"
        :aria-labelledby="propsData.headingId"
    >
        <div
            ref="content"
            class="
                fixed bottom-0 right-0 w-full h-auto pb-14 box-border bg-uiWhite overflow-scroll transition-transform duration-300
                mediumMax:max-h-[calc(100dvh_-_1.25rem)] mediumMax:rounded-t-[2rem]
                medium:translate-y-0 medium:max-w-[35rem] medium:h-dvh medium:rounded-l-[2rem]
                js-overlay-content
            "
            :class="[isActive ? 'translate-y-0 medium:translate-x-0' : 'translate-y-full medium:translate-x-full']"
        >
            <div
                class="sticky z-1 top-0 left-0 py-5 px-8 bg-uiWhite"
                :class="{'max-w-max ml-auto': propsData.reducedHeadingSpace}"
            >
                <div class="flex items-center justify-between gap-5 large:gap-10">
                    <slot
                        name="Heading"
                    />
                    <button
                        class="text-primary rounded-full p-[1.125rem] bg-uiGrey ml-auto transition-colors duration-300 hover:text-uiWhite hover:bg-primary"
                        type="button"
                        :aria-label="$root.config.translations.accessibility.close_overlay"
                        :aria-controls="propsData.id"
                        :aria-expanded="isActive"
                        @click="closeDialog"
                    >
                        <IconClose />
                    </button>
                </div>
            </div>
            <div class="px-8">
                <slot
                    name="Content"
                />
            </div>
            <slot
                name="Footer"
                :close-dialog="closeDialog"
            />
        </div>
    </dialog>
</template>

<script>
    import IconClose from '@/apps/bundle-builder/components/icon/IconClose.vue';

    export default {
        components: {
            IconClose
        },
        props: {
            propsData: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                isActive: false
            };
        },
        mounted () {
            document.addEventListener('click', event => {
                if (this.isActive && !event.target.closest('.js-overlay-content')) {
                    this.closeDialog();
                }
            });

            document.addEventListener('keydown', event => {
                if (this.isActive && event.key === 'Escape') {
                    event.preventDefault();
                    this.closeDialog();
                }
            });
        },
        methods: {
            closeDialog () {
                this.isActive = false;

                document.body.classList.remove('overflow-hidden');

                setTimeout(() => {
                    this.$refs.dialog.close();

                }, getComputedStyle(this.$el.querySelector('.js-overlay-content')).transitionDuration.replace('s', '') * 1000);
            },
            openDialog () {
                this.$refs.dialog.showModal();

                setTimeout(() => {
                    this.isActive = true;

                    document.body.classList.add('overflow-hidden');
                }, 0);
            }
        }
    }
</script>
